
import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage"; // ✅ Storage を追加

//authentic googleログインのみの場合 
import {getAuth, GoogleAuthProvider } from "firebase/auth";
//authentic  googleログイン+メールのみの場合。まずは無効化してgoogleのみで実装する。　
// import { getAuth, GoogleAuthProvider, signInWithPopup, createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyB-z5f5wIi-_fhbJTemeX1fJcH-2YVhAO8",
  authDomain: "uttapps.firebaseapp.com",
  projectId: "uttapps",
  storageBucket: "uttapps.appspot.com", // ✅ 修正 (firebasestorage.app → appspot.com)
  storageBucket: "uttapps.firebasestorage.app",
  messagingSenderId: "855699480562",
  appId: "1:855699480562:web:72f8d62dc8d68a3d1cd56b",
  measurementId: "G-PCKG75CKW4"
};

// const app = initializeApp(firebaseConfig);
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth= getAuth(app);
const provider= new GoogleAuthProvider();
const db= getFirestore(app);
const storage = getStorage(app); // ✅ Storage インスタンスを作成
const analytics = getAnalytics(app);

export{auth, provider, db, analytics, storage}

